import React from 'react';
import { motion } from 'framer-motion';
import { LinkedinIcon, DownloadIcon, MapPinIcon, ArrowUpRightIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { profile } from '../data/profile';
export function ContactFooter() {
  return <footer id="contact" className="relative w-full scroll-mt-20 overflow-hidden border-t-2 border-gold bg-ocean-deep" aria-labelledby="contact-heading" data-id="element-40" data-mp="2ahl8t662iypw">
      <div className="institutional-grid absolute inset-0" aria-hidden="true" data-id="element-41" data-mp="335qupw8uytrb" />

      <div className="relative mx-auto w-full max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-42" data-mp="382h6i7dmr36x">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.55
      }} className="max-w-3xl" data-id="element-43" data-mp="2tf4fi3520595">
          <div className="flex items-center gap-3" data-id="element-44" data-mp="3m1yzz01vf4mm">
            <span className="h-[2px] w-10 bg-gold" aria-hidden="true" data-id="element-45" data-mp="3quieq0cao5t0" />
            <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-gold-soft" data-id="element-46" data-mp="3qvtdtmusopds">
              Section 05 · Contact
            </p>
          </div>
          <h2 id="contact-heading" className="mt-8 font-display text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-47" data-mp="2gcu79c6642ys">
            Directing Mission-Critical Initiatives for Enterprise Success.
          </h2>

          <dl className="mt-10 grid grid-cols-1 gap-px overflow-hidden border border-white/15 bg-white/15 sm:grid-cols-2" data-id="element-48" data-mp="33zajapxh1qdp">
            <div className="bg-ocean-deep p-6" data-id="element-49" data-mp="2z3lb5y7dz15s">
              <dt className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-50" data-mp="3d1jr381cv5ne">
                <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-51" data-mp="390zpns9r1fvg" />
                Email
              </dt>
              <dd className="mt-3" data-id="element-52" data-mp="1inirgkxzeem9">
                <a href={`mailto:${profile.email}`} className="font-display text-lg font-bold text-white underline-offset-4 transition-colors hover:text-gold-soft hover:underline" data-id="element-53" data-mp="1elx8chuut43m">
                  {profile.email}
                </a>
              </dd>
            </div>
            <div className="bg-ocean-deep p-6" data-id="element-54" data-mp="3nobmm6rorowi">
              <dt className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-55" data-mp="3nqo2medvvp6x">
                <PhoneIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-56" data-mp="k58yrmj6ojd" />
                Direct
              </dt>
              <dd className="mt-3" data-id="element-57" data-mp="5i6r9ac4ujts">
                <a href={profile.phoneHref} className="font-display text-lg font-bold text-white underline-offset-4 transition-colors hover:text-gold-soft hover:underline" data-id="element-58" data-mp="5h5hraarm5e6">
                  {profile.phone}
                </a>
              </dd>
            </div>
          </dl>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-59" data-mp="o9g3hrdafmp2">
            <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-3 border border-gold bg-gold px-7 py-4 font-display text-xs font-bold uppercase tracking-[0.18em] text-navy transition-colors hover:bg-gold-soft" data-id="element-60" data-mp="o7dhdif9adpm">
              <LinkedinIcon className="h-4 w-4" data-id="element-61" data-mp="1usr8x7ct6i9d" />
              Connect on LinkedIn
              <ArrowUpRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-62" data-mp="2sfraiqi9rlqo" />
            </a>
            <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 border border-white/25 px-7 py-4 font-display text-xs font-bold uppercase tracking-[0.18em] text-white transition-colors hover:border-white hover:bg-white/5" data-id="element-63" data-mp="2nihpro5try96">
              <DownloadIcon className="h-4 w-4" data-id="element-64" data-mp="36e7q76y40mky" />
              Download PDF Profile
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-65" data-mp="2qvodw0qizk9r">
            <span className="inline-flex items-center gap-2 border border-white/20 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/80" data-id="element-66" data-mp="2uz341k86hh0x">
              <MapPinIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-67" data-mp="2ly4yuym073gr" />
              {profile.location}
            </span>
            <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gold-soft underline-offset-4 hover:underline" data-id="element-68" data-mp="39n7ha8ogp0cb">
              {profile.linkedinLabel}
            </a>
          </div>
        </motion.div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-69" data-mp="34uxqyrjfpy9i">
          <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-white" data-id="element-70" data-mp="17nrjjn02020">
            {profile.name}
          </p>
          <p className="text-[11px] uppercase tracking-[0.14em] text-white/50" data-id="element-71" data-mp="1lx1i5avvnfi9">
            © {new Date().getFullYear()} {profile.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}